import EventEmitter from "eventemitter3";
import { action } from "mobx";
import { Pane, PaneViewMode } from "../Types";
import { activePaneStates, selectedPaneIdsAtom } from "./CanvasState";

export const FocusPaneEmitter = new EventEmitter();
FocusPaneEmitter.addListener(
  "focus",
  action(() => {
    if (selectedPaneIdsAtom.value.length > 0) {
      selectedPaneIdsAtom.value = [];
    }
  })
);

export function focusPaneInDirection(
  panes: Pane[],
  currentPaneId: string,
  direction: "up" | "down" | "right" | "left",
  isMagicLayout: boolean
) {
  const currentPaneRect = activePaneStates.get(currentPaneId)!.rect.get();
  function getMainAxisDistance(pane: Pane) {
    const activePaneState = activePaneStates.get(pane.id)!;
    if (activePaneState.viewMode.get() === PaneViewMode.Hidden) {
      return -1;
    }
    const paneRect = activePaneState.rect.get();
    switch (direction) {
      case "up":
        return currentPaneRect[1] - (paneRect[1] + paneRect[3]);
      case "down":
        return paneRect[1] - (currentPaneRect[1] + currentPaneRect[3]);
      case "left":
        return currentPaneRect[0] - (paneRect[0] + paneRect[2]);
      case "right":
        return paneRect[0] - (currentPaneRect[0] + currentPaneRect[2]);
    }
  }
  function getCrossAxisDistance(pane: Pane): number {
    const paneRect = activePaneStates.get(pane.id)!.rect.get();
    switch (direction) {
      case "up":
      case "down":
        return Math.max(
          paneRect[0] - (currentPaneRect[0] + currentPaneRect[2]),
          currentPaneRect[0] - (paneRect[0] + paneRect[2]),
          0
        );
      case "left":
      case "right":
        return Math.max(
          paneRect[1] - (currentPaneRect[1] + currentPaneRect[3]),
          currentPaneRect[1] - (paneRect[1] + paneRect[3]),
          0
        );
    }
  }
  let paneToFocus: Pane | undefined;
  let minScore: [number, number] | undefined;
  function isScoreSmaller(
    score: [number, number],
    prevScore: [number, number]
  ) {
    if (score[1] === 0 && prevScore[1] !== 0) {
      return true;
    }
    if (prevScore[1] === 0 && score[1] !== 0) {
      return false;
    }
    return 100 * score[0] + score[1] < 100 * prevScore[0] + prevScore[1];
  }
  panes.forEach((p) => {
    const mainAxisDistance = getMainAxisDistance(p);
    if (mainAxisDistance < 0) {
      return;
    }
    const score: [number, number] = [mainAxisDistance, getCrossAxisDistance(p)];
    if (minScore === undefined || isScoreSmaller(score, minScore)) {
      paneToFocus = p;
      minScore = score;
    }
  });
  if (paneToFocus !== undefined) {
    FocusPaneEmitter.emit("focus", {
      paneId: paneToFocus.id,
      noScroll: isMagicLayout,
    });
  }
}
